export default __webpack_public_path__ + "static/media/lhd-range-hero-desktop.207665e1.jpg";